const leagues = [
    { value: 1, label: `National League` },
    { value: 325, label: `Women's Hockey` },
    { value: 348257, label: `Women's Cup` },
    { value: 735293, label: `U21-Elit` },
    { value: 729951, label: `U18-Elit` },
];

export default leagues;
